import { fetchAndActivate, getAll, getRemoteConfig, Value } from 'firebase/remote-config';

export const getFeatureFlag = async () => {
  const remoteConfig = getRemoteConfig();
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

  const response = await fetchAndActivate(remoteConfig)
    .then(() => {
      return getAll(remoteConfig);
    })
    .catch((error) => console.error(error));
  return response as Record<string, Value & { _value: string }>;
};
